<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="我的钱包" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="div account_header">
      <div class="div predeposit ">
        <span class="predeposit_title">购物积分：</span><span class='available_predeposit'>{{parseFloat(mk).toFixed(2)}}</span>		
      </div>
	  <div class="div amount-wrapper" style="margin-top: 0.5rem;">
	    <div class="div amount_item">分红积分：{{parseFloat(exp).toFixed(2)}}</div>		
	    <div class="div amount_item">总收益：{{parseFloat(tv).toFixed(2)}}</div>
		<div class="div amount_item">消费积分：{{parseFloat(sv).toFixed(2)}}</div>
	  </div>
    </div>
	<!--<div class="div card-wrapper">
		<div class="div card_item">
			<img class="img" src="../../../assets/image/member/icon_daijinquan_nor.png"></img>
			<div class="explain">贡献值：{{exp * 1}}</div>
		</div>
		<div class="border"></div>
		<div class="div card_item" @click="$router.push({name:'MemberPointList'})">
			<img class="img" src="../../../assets/image/member/icon_jifen_nor.png"></img>
			<div class="explain">抢购积分：{{points * 1}}</div>
		</div>
	</div>-->
	<!--<div class="div predeposit_handle mt-5">
	  <div class="div item" @click="showpay=true"><img class="img" src="../../../assets/image/member/icon_chongzhi_pre.png" /><span>转入</span></div>
	  <div class="div item" @click="goShow(0)"><img class="img" src="../../../assets/image/member/icon_tixian_pre.png" /><span>转出</span></div>
	  <div class="div item" @click="goShow(1)"><img class="img" src="../../../assets/image/member/icon_purse_pre.png" /><span>划转</span></div>
	  <div class="div item" @click="goAdd()"><img class="img" src="../../../assets/image/member/icon_refund_pre.png"/><span>兑换</span></div>
	  <div class="but item" @click="$router.push({name:'MemberWithdrawList'})">提 现</div>
	</div>-->
	<div class="div predeposit_handle mt-5">
	   <div class="but item" @click="$router.push({name:'MemberRechargeList'})">充 值</div>
	   <div class="but item" @click="goShow(1)">划 转</div>
	   <div class="but item" @click="goShow(0)">复 购</div>
	</div>
	<div class="div account mt-5">
	  <div class="div menu">
        <div class="div" @click="$router.push({name:'MemberPredepositList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">购物积分明细</span></flex-line></div>		  
		<div class="div" @click="$router.push({name:'MemberExppointsList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">分红积分明细</span></flex-line></div>
		<div class="div" @click="$router.push({name:'MemberPointList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">消费积分明细</span></flex-line></div>
		
		<!--<div class="div" @click="$router.push({name:'MemberPointsOrderList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">产品兑换记录</span></flex-line></div>
	    <div class="div" @click="$router.push({name:'MemberBankList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">我的提现账户</span></flex-line></div>
	    <div class="div" @click="$router.push({name:'MemberRechargeCardList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">我的充值卡</span></flex-line></div>
	    <div class="div" @click="$router.push({name:'MemberBonusreceive'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="span line-name">红包领取记录</span></flex-line></div>-->
	  </div>
	</div>
	
	<!--转入-->
	<mt-popup v-model="showpay" position="right" class="common-popup-wrapper">
	    <div class="common-header-wrap">
	        <mt-header title="金豆转入" class="common-header">
	            <mt-button slot="left" icon="back" @click="showpay=false"></mt-button>
	        </mt-header>
	    </div>
	    <div class="common-popup-content">	        
	      <div class="desc-text"><b style="color:royalblue">转入说明:</b>请在转入完成后截屏保存一下转入成功的记录，方便出现问题的时候可以申请人工核对。</div>
		  <div style="text-align: center;">
			  <img style="width:8rem;height:8rem;"/>
			  <div>通道金豆转入地址</div>
			  <div><input style="width:80%;text-align: center;" class="field-input" :value="mkadd"/></div>
			  <div class="but" @click="copy(mkadd)">复制转入地址</div>
		  </div>
	    </div>
	</mt-popup>
	
	<!--复购-->
	<mt-popup v-model="showcash" position="right" class="common-popup-wrapper">
	    <div class="common-header-wrap">
	        <mt-header title="申请复购" class="common-header">
	            <mt-button slot="left" icon="back" @click="showcash=false"></mt-button>
	        </mt-header>
	    </div>
	    <div class="common-popup-content">	        
	      <div class="desc-text"><b style="color:royalblue">说明:</b>分红积分大于5970时才能参与复购，其中1990自动兑换为购物积分。</div>
		  <flex-line class="field-line menu-item" :show-border="true">
		  	<span class="field-name">分红积分</span>
		  	<div class="field-line-right" slot="right"><input class="field-input" readonly="readonly" :value="parseFloat(exp).toFixed(2)"/></div>
		  </flex-line>
		  <flex-line class="field-line menu-item" :show-border="true">
		  	<span class="field-name">安 全 码</span>
		  	<div class="field-line-right" slot="right">
		  		<input class="field-input" type="password" placeholder="请输入安全码" v-model="pass"/>		  		
		  	</div>
		  </flex-line>
		  <div class="but" @click="goOpt(0)">申请复购</div>
	    </div>
	</mt-popup>
	
	<!--划转-->
	<mt-popup v-model="showchang" position="right" class="common-popup-wrapper">
	    <div class="common-header-wrap">
	        <mt-header title="购物积分划转" class="common-header">
	            <mt-button slot="left" icon="back" @click="showchang=false"></mt-button>
	        </mt-header>
	    </div>
	    <div class="common-popup-content">	        
	      <div class="desc-text"><b style="color:royalblue">说明:</b>划转用于内部转账。</div>
		  <flex-line class="field-line menu-item" :show-border="true">
		  	<span class="field-name">积分类型</span>
		  	<div class="field-line-right" slot="right"><input class="field-input" readonly="readonly" value="购物积分"/></div>
		  </flex-line>
		  <flex-line class="field-line menu-item" :show-border="true">
		  	<span class="field-name">对方帐号</span>
		  	<div class="field-line-right" slot="right">
		  		<input class="field-input" placeholder="请输入对方登录帐号" v-model="address"/>		  		
		  	</div>
		  </flex-line>
		  <flex-line class="field-line menu-item" :show-border="true">
		  	<span class="field-name">划转金额</span>
		  	<div class="field-line-right" slot="right">
		  		<input class="field-input" :placeholder="'可转出'+mk+'购物积分'" v-model="num"/>		  		
		  	</div>
		  </flex-line>
		  <flex-line class="field-line menu-item" :show-border="true">
		  	<span class="field-name">安 全 码</span>
		  	<div class="field-line-right" slot="right">
		  		<input class="field-input" type="password" placeholder="请输入安全码" v-model="pass"/>		  		
		  	</div>
		  </flex-line>
		  <div class="but" @click="goOpt(1)">立即划转</div>
	    </div>
	</mt-popup>
  </div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { getMemberIndex, optMk} from '../../../api/member'
import { mapState } from 'vuex'
import flexLine from '../../flexLine'
import Clipboard from 'clipboard'
export default {
  components: {
    flexLine
  },
  data () {
    return {
      mk: 0,      
      sv: 0,
	  tv: 0,
	  exp:0,
	  mkadd:'',
	  qrcode:'',
	  tocode:'',
	  cash:0,
	  
	  address:'',
	  num:'',
	  pass:'',
			
	  showpay:false,
	  showcash:false,
	  showchang:false,
    }
  },
  created () {
    getMemberIndex().then(
      response => {
        if (response && response.result.member_info) {
          this.mk  = response.result.member_info.available_predeposit * 1
		  this.sv  = response.result.member_info.member_points  * 1
		  this.tv  = response.result.member_info.total_win  * 1
          this.exp = response.result.member_info.member_exppoints  * 1
		  this.mkadd = response.result.member_info.mkadd
		  this.qrcode = response.result.member_info.qrcode
		  this.cash = response.result.member_info.cash
        }
      },
      error => {}
    )
  },
  computed: {

  },
  mounted () {

  },
  methods: {
	 copy(tex) {
	   let _this = this
	   let clip = new Clipboard('.copy', {
	     text: () => {
	       return tex
	     }
	   })
	   //复制成功
	   clip.on('success', function() {
	 	  Toast('复制成功！')
	 	  clip.destroy()
	   });
	   //复制失败
	   clip.on('error', function() {
	       Toast('复制失败,请手动复制！')
	       clip.destroy()
	   });
	 },
	 goShow(type)
	 {
		 this.address = '';
		 this.num = '';
		 this.pass= '';		
	     type == 0 ? this.showcash = true : this.showchang = true;	     
	 },
     goOpt (type) {	
	   Indicator.open()
       optMk(type, this.address, this.num, this.pass).then(res => {          
		  Indicator.close()
		  Toast(res.message)
		  this.$router.go(0)
       }).catch(function (error) {
		  Indicator.close()
          Toast(error.message)		  
       })
     },
  }
}
</script>
<style scoped lang="scss">
  .common-header-wrap .common-header{box-shadow: unset}
  .account_header{
    background: linear-gradient(360deg, #69b8fd 0%, #81c0fa 100%);
    color: #fff;
    padding: .7rem;
    font-size:$fontSize;
    box-sizing: border-box;
    .predeposit{
      padding: 1.5rem 0;
      margin-top:0rem;
      display: flex;
  	  justify-content: center;
  	  align-items: center;
  	  .predeposit_title{
  		  font-size: 1.5rem;
  	  }
      .available_predeposit{
        font-size:1.5rem;
      }  
    }
    .amount-wrapper{
      margin-top: 1.5rem;
      padding-top:.7rem;
      border-top:1px dashed rgba(255,255,255,.5);
      overflow: hidden;
      .amount_item{
        float: left;
        width: 33.3%;
      }
	  .amount_item:nth-child(2){
	    text-align: center;
	  }
      .amount_item:nth-child(3){
        text-align: right;
      }
    }
  }
  .card-wrapper{
  	background-color: #fff;
  	display: flex;
  	padding: .5rem 0;
  	justify-content: center;
  	align-items: center;
  	.card_item{
  		width: 36%;
  		margin: 0 6%;
  		background-color: #F5A623;
  		padding: .8rem 0;
  		border-radius: .5rem;
  		text-align: center;
  		.img{
  			width: 1.5rem;
  			height: 1.5rem;
  		}
  		.explain{
  			font-size: $subFontSize;
  			color: #fff;
  		}
  	}
  	.card_item:nth-child(3){
  		background-color: #FF862F;
  	}
  	.border{
  		width: 1px;
  		background-color: #cdcdcd;
  		height: 2.8rem;
  	}
  }
  .predeposit_handle{
    height: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    background-color: #fff;
    .item{
      display: flex;
	  flex-direction : column;
      justify-content: center;
      align-items: center;
  	  flex: 1;
      .img{
        width: 2rem;
        height: 2rem;
      }
  	  span{
		padding-left:.2rem;
  		font-size: .9rem;
  		color: #666;
  	  }
    }
  }
  .account{
    padding: 0 $pageSpace;
    background: #fff;
  
    .menu{
      background: #fff;
    }
  }
  .common-popup-content
  {
	  width:92%;
	  padding:0 0.7rem;
	  line-height:1.5rem;
	  font-size:$subFontSize;
	  .desc-text{border-bottom:0.2rem solid #eee;}
	  .but{color:#fff; padding:0.2rem;text-align:center; font-weight:bold; background:#f00; border-radius:0.2rem; margin-top:1.5rem;}
  }
  .but{color:#fff; margin:1rem; padding:0.5rem; text-align:center; background:#69b8fd; border-radius:0.2rem;}
</style>